import { ISelectOption } from '../../../interface';

export class SelectOptionDto implements ISelectOption {
  public label = '';
  public value = '';
  public category = '';

  constructor(label = '', value = '', category = '') {
    this.label = label;
    this.value = value;
    this.category = category;
  }
}
